import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/pessoavinculos`, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/pessoavinculos/${id}`, options)
    .then(response => {
      let pessoavinculo = jsona.deserialize(response.data);
      delete pessoavinculo.links;
      return pessoavinculo;
    });
}

function add(pessoavinculo) {
  const payload = jsona.serialize({
    stuff: pessoavinculo,
    includeNames: ["categories"]
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  //.post(`${url}/pessoavinculos`, payload, options)
  return axios
    .post(`${url}/pessoavinculos`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(pessoavinculo) {
  const payload = jsona.serialize({
    stuff: pessoavinculo,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  return axios
    .patch(`${url}/pessoavinculos/${pessoavinculo.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.delete(`${url}/pessoavinculos/${id}`, options);
}
function downloadPDF(tipo, arquivo) {
  return axios.get(`${url}/downloads/${tipo}/${arquivo}.pdf`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
/*
function upload(pessoavinculo, image) {
  const bodyFormData = new FormData();
  bodyFormData.append("attachment", image);

  return axios
    .post(`${url}/uploads/pessoavinculos/${pessoavinculo.id}/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  upload
};
*/
export default {
  list,
  get,
  add,
  update,
  destroy,
  downloadPDF
};